<template>
  <div class="member-des-container">
    <div class="des-item" :key="text" v-for="text in memberDes">
      <div>
        <div class="icon"></div>
      </div>
      <div>{{ text }}</div>
    </div>
  </div>
</template>

<script>
export default {
  name: "Des2Component",
  data() {
    const _this = this;
    return {
      memberDes: [
        _this.$t("inviteMemberPage.des5"),
        _this.$t("inviteMemberPage.des7"),
        _this.$t("inviteMemberPage.des8"),
        _this.$t("inviteMemberPage.des9"),
      ],
    };
  },
};
</script>

<!-- Add "scoped" attribute to limit CSS to this component only -->
<style scoped lang="less">
.member-des-container {
  padding: 0;
  font-size: 16px;
  .des-item {
    display: flex;
    line-height: 23px;
    .icon {
      width: 6px;
      height: 6px;
      background: #000;
      border-radius: 50%;
      position: relative;
      top: 9px;
      margin: 0 6px;
    }
    &:first-child {
      margin-top: 0;
    }
  }
}
</style>
